export const INVOICE_MAX_BYTES = 10 * 1024 * 1024

export function normalizeFee(value) {
  const n = Number(value)
  if (!Number.isFinite(n) || n < 0) return 0
  return Math.round(n * 100) / 100
}

export function feeExceedsAmount(direction, amount, fee) {
  if (direction !== 'income') return false
  const amt = Number(amount)
  if (!Number.isFinite(amt)) return false
  return normalizeFee(fee) > amt
}

export function moneyEffect({
  direction, amount, fee, balance,
}) {
  const amt = Number(amount)
  const amountValue = Number.isFinite(amt) ? amt : 0
  const feeValue = normalizeFee(fee)
  const moved = direction === 'income' ? amountValue - feeValue : amountValue + feeValue
  const signed = direction === 'income' ? moved : -moved
  const current = Number(balance)
  const hasBalance = balance != null && balance !== '' && Number.isFinite(current)
  const next = hasBalance ? Math.round((current + signed) * 100) / 100 : null
  return {
    fee: feeValue,
    amount: amountValue,
    moved: Math.round(moved * 100) / 100,
    nextBalance: next,
    negative: next != null && next < 0,
    feeExceedsAmount: feeExceedsAmount(direction, amountValue, feeValue),
  }
}

export function invoiceFileError(file) {
  if (!file) return null
  const name = String(file.name || '').toLowerCase()
  if (!/\.(pdf|jpe?g|png)$/.test(name)) return 'type'
  if (file.size > INVOICE_MAX_BYTES) return 'size'
  return null
}

export function withInvoiceFile(fields, invoiceFile) {
  const payload = { ...fields }
  payload.fee = normalizeFee(payload.fee)
  if (!(invoiceFile instanceof File)) return payload
  const data = new FormData()
  Object.keys(payload).forEach(key => {
    const value = payload[key]
    if (value === null || value === undefined || value === '') return
    data.append(key, value)
  })
  if (!data.has('fee')) data.append('fee', String(payload.fee))
  data.append('invoice', invoiceFile)
  return data
}

export function invoiceMedia(item) {
  const invoice = item && item.invoice
  if (Array.isArray(invoice)) return invoice.find(file => file && (file.url || file.download_url)) || null
  if (invoice && typeof invoice === 'object' && (invoice.url || invoice.download_url)) return invoice
  return null
}
